module.exports = __webpack_public_path__ + "static/media/bottomNewAndroid.122bb79f.png";